module.exports = __webpack_public_path__ + "static/media/star-active.d4a6df0c.svg";